export default __webpack_public_path__ + "static/media/googletagmanager.79df5101.svg";